import React from "react";
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import MemberEmailUnsubscribeOptions from "./MemberEmailUnsubscribeOptions";
import MemberEmailUnsubscribe from "./MemberEmailUnsubscribe";

const MemberEmailUnsubscribeRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/:email`}>
                <MemberEmailUnsubscribeOptions />
            </Route>
            <Route default path={`${path}`}>
                <MemberEmailUnsubscribe />
            </Route>
        </Switch>
    );
};

export default MemberEmailUnsubscribeRouter;
